namespace TabAurous.Inventory {
    export interface RejectionRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        AutoPosting?: boolean;
        DepartmentId?: number;
        RejectionType?: number;
        PartyId?: number;
        POSCustomerId?: number;
        TermsId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        Roundoff?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        AddressId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        FinancialYearId?: number;
        UserId?: number;
        ItemDetails?: RejectionItemsRow[];
        ProductItemImage?: string;
        PostingDate?: string;
        IsPosted?: boolean;
        Username?: string;
    }

    export namespace RejectionRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Inventory.Rejection';
        export const deletePermission = 'Inventory:RejectionIn:Delete';
        export const insertPermission = 'Inventory:RejectionIn:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:RejectionIn:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            AutoPosting = "AutoPosting",
            DepartmentId = "DepartmentId",
            RejectionType = "RejectionType",
            PartyId = "PartyId",
            POSCustomerId = "POSCustomerId",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            Roundoff = "Roundoff",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            AddressId = "AddressId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            FinancialYearId = "FinancialYearId",
            UserId = "UserId",
            ItemDetails = "ItemDetails",
            ProductItemImage = "ProductItemImage",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            Username = "Username"
        }
    }
}
